export default __webpack_public_path__ + "static/media/debbi-headshot.d392bba8.jpg";